import whiteboardRoute from "./whiteboard.Route";

const whiteboardRoutesList = [...whiteboardRoute];

export default whiteboardRoutesList;
